var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7766 12.1457C16.3357 12.1457 15.1675 13.3139 15.1675 14.7549V50.9441C15.1675 52.0802 16.0886 53 17.2234 53H50.9436C52.0791 53 52.9995 52.0796 52.9995 50.9441V14.7548C52.9995 13.3138 51.8313 12.1456 50.3903 12.1456L17.7766 12.1457Z",
    fill: "url(#paint0_linear_290_3534)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0863 32.6316V12.1458H17.7766C16.3357 12.1458 15.1675 13.3139 15.1675 14.7549V32.6316H34.0863Z",
    fill: "url(#paint1_linear_290_3534)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3905 12.1456H27.2524C27.559 13.2784 27.72 14.4589 27.72 15.6613C27.72 17.7303 27.2534 19.6913 26.42 21.4455C24.379 25.7395 20.141 28.7948 15.1674 29.1492V50.9435C15.1674 52.0804 16.0881 53.0001 17.2229 53.0001H50.9434C52.0792 53.0001 53 52.0793 53 50.9435V14.7551C53 13.3137 51.8319 12.1456 50.3905 12.1456Z",
    fill: "url(#paint2_linear_290_3534)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1669 38.7675V50.9434C15.1669 52.0796 16.088 52.9999 17.2234 52.9999H50.9435C52.0798 52.9999 53 52.0796 53 50.9434V38.7675H15.1669Z",
    fill: "url(#paint3_linear_290_3534)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3904 12.1458H17.7766C16.3357 12.1458 15.1675 13.3138 15.1675 14.7548V21.445H52.9996V14.7548C52.9996 13.3138 51.8314 12.1458 50.3904 12.1458Z",
    fill: "url(#paint4_linear_290_3534)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0863 12.1458H17.7766C16.3357 12.1458 15.1675 13.3139 15.1675 14.7548V21.445H34.0863V12.1458Z",
    fill: "url(#paint5_linear_290_3534)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3905 12.1458H20.3229V13.9051L27.8629 21.4451H52.9995V14.7549C52.9996 13.3138 51.8315 12.1458 50.3905 12.1458Z",
    fill: "url(#paint6_linear_290_3534)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9999 14.7551V21.4455H26.4199C27.2534 19.6913 27.72 17.7303 27.72 15.6613C27.72 14.4589 27.5589 13.2784 27.2523 12.1456H50.3905C51.8319 12.1456 52.9999 13.3137 52.9999 14.7551Z",
    fill: "url(#paint7_linear_290_3534)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3904 12.1458H31.2559V13.9051L38.7959 21.4451H52.9995V14.7549C52.9996 13.3138 51.8314 12.1458 50.3904 12.1458Z",
    fill: "url(#paint8_linear_290_3534)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3903 12.1458H42.1888V13.9051L49.7289 21.4451H52.9995V14.7549C52.9995 13.3138 51.8313 12.1458 50.3903 12.1458Z",
    fill: "url(#paint9_linear_290_3534)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2921 28.021H21.6005C20.7677 28.021 20.0925 27.3459 20.0925 26.513V25.0888C20.0925 24.256 20.7677 23.5808 21.6005 23.5808H26.2921C27.1249 23.5808 27.8001 24.256 27.8001 25.0888V26.513C27.8001 27.346 27.1249 28.021 26.2921 28.021Z",
    fill: "url(#paint10_linear_290_3534)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4292 28.021H31.7376C30.9048 28.021 30.2296 27.3459 30.2296 26.513V25.0888C30.2296 24.256 30.9048 23.5808 31.7376 23.5808H36.4292C37.262 23.5808 37.9372 24.256 37.9372 25.0888V26.513C37.9372 27.346 37.262 28.021 36.4292 28.021Z",
    fill: "url(#paint11_linear_290_3534)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5664 28.021H41.8748C41.042 28.021 40.3668 27.3459 40.3668 26.513V25.0888C40.3668 24.256 41.042 23.5808 41.8748 23.5808H46.5664C47.3992 23.5808 48.0744 24.256 48.0744 25.0888V26.513C48.0744 27.346 47.3992 28.021 46.5664 28.021Z",
    fill: "url(#paint12_linear_290_3534)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2921 35.1421H21.6005C20.7677 35.1421 20.0925 34.467 20.0925 33.6341V32.2099C20.0925 31.3771 20.7677 30.7019 21.6005 30.7019H26.2921C27.1249 30.7019 27.8001 31.3771 27.8001 32.2099V33.6341C27.8001 34.467 27.1249 35.1421 26.2921 35.1421Z",
    fill: "url(#paint13_linear_290_3534)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4292 35.1421H31.7376C30.9048 35.1421 30.2296 34.467 30.2296 33.6341V32.2099C30.2296 31.3771 30.9048 30.7019 31.7376 30.7019H36.4292C37.262 30.7019 37.9372 31.3771 37.9372 32.2099V33.6341C37.9372 34.467 37.262 35.1421 36.4292 35.1421Z",
    fill: "url(#paint14_linear_290_3534)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5664 35.1421H41.8748C41.042 35.1421 40.3668 34.467 40.3668 33.6341V32.2099C40.3668 31.3771 41.042 30.7019 41.8748 30.7019H46.5664C47.3992 30.7019 48.0744 31.3771 48.0744 32.2099V33.6341C48.0744 34.467 47.3992 35.1421 46.5664 35.1421Z",
    fill: "url(#paint15_linear_290_3534)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2921 42.2636H21.6005C20.7677 42.2636 20.0925 41.5884 20.0925 40.7556V39.3314C20.0925 38.4985 20.7677 37.8234 21.6005 37.8234H26.2921C27.1249 37.8234 27.8001 38.4985 27.8001 39.3314V40.7556C27.8001 41.5884 27.1249 42.2636 26.2921 42.2636Z",
    fill: "url(#paint16_linear_290_3534)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4292 42.2636H31.7376C30.9048 42.2636 30.2296 41.5884 30.2296 40.7556V39.3314C30.2296 38.4985 30.9048 37.8234 31.7376 37.8234H36.4292C37.262 37.8234 37.9372 38.4985 37.9372 39.3314V40.7556C37.9372 41.5884 37.262 42.2636 36.4292 42.2636Z",
    fill: "url(#paint17_linear_290_3534)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5664 42.2636H41.8748C41.042 42.2636 40.3668 41.5884 40.3668 40.7556V39.3314C40.3668 38.4985 41.042 37.8234 41.8748 37.8234H46.5664C47.3992 37.8234 48.0744 38.4985 48.0744 39.3314V40.7556C48.0744 41.5884 47.3992 42.2636 46.5664 42.2636Z",
    fill: "url(#paint18_linear_290_3534)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2921 49.3844H21.6005C20.7677 49.3844 20.0925 48.7093 20.0925 47.8764V46.4522C20.0925 45.6194 20.7677 44.9442 21.6005 44.9442H26.2921C27.1249 44.9442 27.8001 45.6194 27.8001 46.4522V47.8764C27.8001 48.7093 27.1249 49.3844 26.2921 49.3844Z",
    fill: "url(#paint19_linear_290_3534)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4292 49.3844H31.7376C30.9048 49.3844 30.2296 48.7093 30.2296 47.8764V46.4522C30.2296 45.6194 30.9048 44.9442 31.7376 44.9442H36.4292C37.262 44.9442 37.9372 45.6194 37.9372 46.4522V47.8764C37.9372 48.7093 37.262 49.3844 36.4292 49.3844Z",
    fill: "url(#paint20_linear_290_3534)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.784 14.4071H21.5166C20.5449 14.4071 19.7572 13.6194 19.7572 12.6478V10.5115C19.7572 9.5398 20.5449 8.75208 21.5166 8.75208H24.784C25.7557 8.75208 26.5434 9.5398 26.5434 10.5115V12.6478C26.5433 13.6195 25.7557 14.4071 24.784 14.4071Z",
    fill: "url(#paint21_linear_290_3534)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.784 14.4071H21.5166C20.5449 14.4071 19.7572 13.6194 19.7572 12.6478V10.5115C19.7572 9.5398 20.5449 8.75208 21.5166 8.75208H24.784C25.7557 8.75208 26.5434 9.5398 26.5434 10.5115V12.6478C26.5433 13.6195 25.7557 14.4071 24.784 14.4071Z",
    fill: "url(#paint22_linear_290_3534)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7171 14.4071H32.4497C31.478 14.4071 30.6903 13.6194 30.6903 12.6478V10.5115C30.6903 9.5398 31.478 8.75208 32.4497 8.75208H35.7171C36.6888 8.75208 37.4765 9.5398 37.4765 10.5115V12.6478C37.4764 13.6195 36.6888 14.4071 35.7171 14.4071Z",
    fill: "url(#paint23_linear_290_3534)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6502 14.4071H43.3828C42.4111 14.4071 41.6234 13.6194 41.6234 12.6478V10.5115C41.6234 9.5398 42.4111 8.75208 43.3828 8.75208H46.6502C47.6219 8.75208 48.4096 9.5398 48.4096 10.5115V12.6478C48.4095 13.6195 47.6219 14.4071 46.6502 14.4071Z",
    fill: "url(#paint24_linear_290_3534)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1977 25.9954C19.8853 25.9954 24.496 21.3848 24.496 15.6972C24.496 10.0096 19.8853 5.39893 14.1977 5.39893C8.51013 5.39893 3.89941 10.0096 3.89941 15.6972C3.89941 21.3848 8.51013 25.9954 14.1977 25.9954Z",
    fill: "url(#paint25_linear_290_3534)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1977 24.4886C19.053 24.4886 22.9891 20.5526 22.9891 15.6973C22.9891 10.842 19.053 6.90601 14.1977 6.90601C9.34239 6.90601 5.40637 10.842 5.40637 15.6973C5.40637 20.5526 9.34239 24.4886 14.1977 24.4886Z",
    fill: "url(#paint26_linear_290_3534)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1977 23.0269C18.2458 23.0269 21.5275 19.7453 21.5275 15.6972C21.5275 11.6491 18.2458 8.36743 14.1977 8.36743C10.1496 8.36743 6.86792 11.6491 6.86792 15.6972C6.86792 19.7453 10.1496 23.0269 14.1977 23.0269Z",
    fill: "url(#paint27_linear_290_3534)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3352 18.6135C16.2328 18.6137 16.1314 18.5936 16.0368 18.5544C15.9423 18.5153 15.8563 18.4578 15.784 18.3853L13.6465 16.2479C13.5004 16.1017 13.4183 15.9034 13.4183 15.6967V10.5149C13.4183 10.0843 13.7672 9.73547 14.1977 9.73547C14.6283 9.73547 14.9772 10.0843 14.9772 10.5149V15.3739L16.8864 17.283C16.9954 17.3921 17.0696 17.5309 17.0997 17.6821C17.1298 17.8333 17.1143 17.99 17.0553 18.1324C16.9963 18.2749 16.8964 18.3966 16.7682 18.4822C16.6401 18.5679 16.4894 18.6136 16.3352 18.6135Z",
    fill: "url(#paint28_linear_290_3534)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.216 3.35248C21.1271 3.3018 21.029 3.26914 20.9275 3.25636C20.8259 3.24358 20.7228 3.25093 20.6241 3.27799C20.5254 3.30505 20.433 3.35129 20.3522 3.41407C20.2713 3.47685 20.2036 3.55493 20.153 3.64387C20.1023 3.7328 20.0696 3.83084 20.0569 3.9324C20.0441 4.03395 20.0514 4.13702 20.0785 4.23574C20.1055 4.33445 20.1518 4.42687 20.2146 4.5077C20.2773 4.58854 20.3554 4.65623 20.4444 4.70688C24.3874 6.95313 26.8368 11.1643 26.8368 15.6969C26.8368 22.6661 21.1669 28.3358 14.1979 28.3358C7.22878 28.3358 1.55882 22.6661 1.55882 15.697C1.55882 9.27026 6.38037 3.94857 12.5962 3.15919V4.01259C12.5962 4.83845 13.5147 5.33269 14.2039 4.87794L16.4567 3.39072C17.0772 2.98138 17.0772 2.06999 16.4567 1.66065L14.2039 0.173435C13.5147 -0.28122 12.5962 0.212925 12.5962 1.03878V1.59019C5.51875 2.38841 0 8.40979 0 15.697C0 23.5257 6.36904 29.8947 14.1978 29.8947C22.0265 29.8947 28.3955 23.5257 28.3955 15.697C28.3955 10.6055 25.6445 5.87547 21.216 3.35248Z",
    fill: "url(#paint29_linear_290_3534)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 1.58973H12.5963V1.03895C12.5963 0.212775 13.515 -0.281889 14.204 0.173285L16.35 1.58973Z",
    fill: "url(#paint30_linear_290_3534)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7074 3.15942C16.6374 3.25005 16.5528 3.32837 16.457 3.39117L14.204 4.87828C13.515 5.33241 12.5963 4.83879 12.5963 4.01262V3.15942H16.7074Z",
    fill: "url(#paint31_linear_290_3534)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_290_3534",
    x1: 19.3856,
    y1: 21.8257,
    x2: 43.2489,
    y2: 39.4974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_290_3534",
    x1: 26.0376,
    y1: 24.8339,
    x2: 23.9592,
    y2: 21.2312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_290_3534",
    x1: 31.9953,
    y1: 30.5749,
    x2: 24.2359,
    y2: 22.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_290_3534",
    x1: 34.0835,
    y1: 46.0013,
    x2: 34.0835,
    y2: 52.0769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_290_3534",
    x1: 34.0835,
    y1: 13.7794,
    x2: 34.0835,
    y2: 21.8864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#FB7C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#F55F19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_290_3534",
    x1: 27.5481,
    y1: 17.3904,
    x2: 23.8069,
    y2: 16.6284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA2E43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#C92744",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#C41346",
    stopOpacity: 0.708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_290_3534",
    x1: 37.6612,
    y1: 15.7183,
    x2: 29.1997,
    y2: 1.01536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA2E43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#C92744",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#C41346",
    stopOpacity: 0.708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_290_3534",
    x1: 33.6012,
    y1: 16.7956,
    x2: 26.7421,
    y2: 16.7956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA2E43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#C92744",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#C41346",
    stopOpacity: 0.708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_290_3534",
    x1: 43.1762,
    y1: 15.8027,
    x2: 36.609,
    y2: 4.39135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA2E43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#C92744",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#C41346",
    stopOpacity: 0.708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_290_3534",
    x1: 48.6912,
    y1: 15.8871,
    x2: 44.0183,
    y2: 7.76733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA2E43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#C92744",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#C41346",
    stopOpacity: 0.708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_290_3534",
    x1: 19.301,
    y1: 15.0215,
    x2: 24.9678,
    y2: 28.1715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_290_3534",
    x1: 29.438,
    y1: 15.0215,
    x2: 35.1049,
    y2: 28.1715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_290_3534",
    x1: 39.5751,
    y1: 15.0215,
    x2: 45.242,
    y2: 28.1715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_290_3534",
    x1: 19.301,
    y1: 22.1425,
    x2: 24.9677,
    y2: 35.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_290_3534",
    x1: 29.438,
    y1: 22.1425,
    x2: 35.1049,
    y2: 35.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_290_3534",
    x1: 39.5751,
    y1: 22.1425,
    x2: 45.242,
    y2: 35.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_290_3534",
    x1: 19.301,
    y1: 29.264,
    x2: 24.9677,
    y2: 42.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_290_3534",
    x1: 29.438,
    y1: 29.264,
    x2: 35.1049,
    y2: 42.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_290_3534",
    x1: 39.5751,
    y1: 29.264,
    x2: 45.242,
    y2: 42.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_290_3534",
    x1: 19.301,
    y1: 36.3849,
    x2: 24.9678,
    y2: 49.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_290_3534",
    x1: 29.438,
    y1: 36.3849,
    x2: 35.1049,
    y2: 49.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_290_3534",
    x1: 22.4635,
    y1: 9.73777,
    x2: 23.8459,
    y2: 13.4449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_290_3534",
    x1: 25.2068,
    y1: 10.366,
    x2: 23.0938,
    y2: 11.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_290_3534",
    x1: 33.3966,
    y1: 9.73777,
    x2: 34.7789,
    y2: 13.4449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_290_3534",
    x1: 44.3297,
    y1: 9.73777,
    x2: 45.712,
    y2: 13.4449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_290_3534",
    x1: 7.48814,
    y1: 8.98753,
    x2: 21.0824,
    y2: 22.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_290_3534",
    x1: 21.9629,
    y1: 23.4625,
    x2: 5.32696,
    y2: 6.82632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_290_3534",
    x1: 11.1143,
    y1: 12.6136,
    x2: 18.355,
    y2: 19.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_290_3534",
    x1: 12.3512,
    y1: 11.2592,
    x2: 18.1819,
    y2: 17.0899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#FB7C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#F55F19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_290_3534",
    x1: 4.16507,
    y1: 5.66119,
    x2: 24.2339,
    y2: 25.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#57D5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#3BC5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#0DABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_290_3534",
    x1: 13.6088,
    y1: 0.794941,
    x2: 11.4955,
    y2: 0.794941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#0389FC",
    stopOpacity: 0.683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_290_3534",
    x1: 13.6088,
    y1: 4.10521,
    x2: 11.4955,
    y2: 4.10521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#0389FC",
    stopOpacity: 0.683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.d29ee85e65a25c24e6df914de5017792.svg";
export { ForwardRef as ReactComponent };